import React from "react";
import PropTypes from "prop-types";
import RelativeLink from "app/pages/.shared/RelativeLink";
import IconPictoChevron from "app/pages/.shared/IconPictoChevron";

const FaqNav = ({ faqCategories }) => {
	return (
		<div className="faq-nav">
			{faqCategories.map(faqCategory => {
				return (
					<div key={faqCategory.id} className="faq-nav__item">
						<RelativeLink
							to={{
								pathname: `/faq/category/${faqCategory.id}`,
							}}
							className="faq-nav__link"
							activeClassName="faq-nav__link--active"
						>
							{faqCategory.name}
						</RelativeLink>
						<div className="faq-nav__subitems">
							{faqCategory.subCategories.map(subCategory => {
								return (
									<div key={subCategory.id} className="faq-nav__subcategory">
										<RelativeLink
											to={{
												pathname: `/faq/category/${
													faqCategory.id
												}/subcategory/${subCategory.id}`,
											}}
											className="faq-nav__link"
											activeClassName="faq-nav__link--active"
										>
											<IconPictoChevron
												height={10}
												width={10}
												style={{ marginRight: "10px" }}
											/>
											{subCategory.name}
										</RelativeLink>
									</div>
								);
							})}
						</div>
					</div>
				);
			})}
		</div>
	);
};

FaqNav.propTypes = {
	faqCategories: PropTypes.array,
};

FaqNav.defaultProps = {
	faqCategories: [],
};

export default React.memo(FaqNav);
